module.exports = __webpack_public_path__ + "img/合作企业.fd80aa81.png";